"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleView = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const RoleView_styled_1 = require("./RoleView.styled");
const localization_1 = require("../../localization");
const Search_1 = require("../../presenters/Search/Search");
const useStore_1 = require("../../contexts/useStore/useStore");
const Title_1 = require("../../components/Title/Title");
const PanelPeople_1 = require("../../presenters/PanelPeople/PanelPeople");
const RoleView = ({ id }) => {
    const { open } = (0, useStore_1.useStore)();
    const role = (0, react_1.useMemo)(() => open('roles').find(id), [id, open]);
    const peopleWithRole = (0, react_1.useMemo)(() => open('people').where((person) => person.attributes['person_roles'].some((other) => other.role.id === id)), [id, open]);
    const peopleWithRoleSorted = (0, react_1.useMemo)(() => open('people').sort(peopleWithRole), [peopleWithRole, open]);
    return ((0, jsx_runtime_1.jsxs)(RoleView_styled_1.RoleViewStyled, { children: [(0, jsx_runtime_1.jsx)(Search_1.Search, { className: "search" }), (0, jsx_runtime_1.jsx)(Title_1.Title, { text: role.attributes['name'] }), (0, jsx_runtime_1.jsx)("h2", { children: localization_1.localization.role.people }), (0, jsx_runtime_1.jsx)(PanelPeople_1.PanelPeople, { people: peopleWithRoleSorted })] }));
};
exports.RoleView = RoleView;
//# sourceMappingURL=RoleView.js.map